import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { forecastBudgetVersionsQueryKeys } from "./queryKeys";

/**
 * Fetches budget versions for a given brand, or the tenant's own when `brand`
 * is null (a tenant-scoped budget belongs to no brand — see `useBudgetScope`).
 */
export function useFetchBudgetVersions(
  brand: string | null,
  enabled: boolean = true
) {
  const apiClient = useApi();

  return useQuery({
    queryKey: forecastBudgetVersionsQueryKeys.data(brand),
    meta: {
      errorMessage: "Failed to fetch forecast budget versions"
    },
    queryFn: async () => {
      const response = await apiClient.POST(
        "/v2/forecast/cubes/budget-versions",
        {
          body: { brand }
        }
      );

      return response.data?.result ?? { budget_versions: [] };
    },
    enabled: enabled && (brand === null || brand.length > 0)
  });
}
